import React from 'react'

const SuiteCasePending: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="41"
      viewBox="0 0 40 41"
      fill="none"
      {...props}
    >
      <path
        d="M6.66671 35.4997C5.75004 35.4997 4.9656 35.1736 4.31337 34.5213C3.66115 33.8691 3.33449 33.0841 3.33337 32.1663V13.833C3.33337 12.9163 3.66004 12.1319 4.31337 11.4797C4.96671 10.8275 5.75115 10.5008 6.66671 10.4997H13.3334V7.16634C13.3334 6.24967 13.66 5.46523 14.3134 4.81301C14.9667 4.16079 15.7512 3.83412 16.6667 3.83301H23.3334C24.25 3.83301 25.035 4.15967 25.6884 4.81301C26.3417 5.46634 26.6678 6.25079 26.6667 7.16634V10.4997H33.3334C34.25 10.4997 35.035 10.8263 35.6884 11.4797C36.3417 12.133 36.6678 12.9175 36.6667 13.833V20.958C36.1667 20.5969 35.6389 20.2847 35.0834 20.0213C34.5278 19.758 33.9445 19.5286 33.3334 19.333V13.833H6.66671V32.1663H18.4584C18.5417 32.7497 18.6667 33.3191 18.8334 33.8747C19 34.4302 19.2084 34.9719 19.4584 35.4997H6.66671ZM16.6667 10.4997H23.3334V7.16634H16.6667V10.4997ZM30 38.833C27.6945 38.833 25.7295 38.0202 24.105 36.3947C22.4806 34.7691 21.6678 32.8041 21.6667 30.4997C21.6656 28.1952 22.4784 26.2302 24.105 24.6047C25.7317 22.9791 27.6967 22.1663 30 22.1663C32.3034 22.1663 34.2689 22.9791 35.8967 24.6047C37.5245 26.2302 38.3367 28.1952 38.3334 30.4997C38.33 32.8041 37.5173 34.7697 35.895 36.3963C34.2728 38.023 32.3078 38.8352 30 38.833ZM30.8334 30.1663V25.4997H29.1667V30.833L32.75 34.4163L33.9167 33.2497L30.8334 30.1663Z"
        fill="#53514E"
      />
    </svg>
  )
}

export default SuiteCasePending
